module.exports = __webpack_public_path__ + "img/brandeeq_s_choice.8ae49d42.svg";